import { useCallback, useRef, useState } from "react";

/**
 * Like `useState`, but the setter drops values that are deep-equal (by JSON)
 * to the last one set. Background WS-driven refetches often return the exact
 * same list; skipping the state update skips the re-render of the map +
 * lists, so a refresh that changed nothing is one the user never sees or
 * feels.
 */
export function useDedupedState<T>(initial: T): [T, (value: T) => void] {
    const [state, setState] = useState(initial);
    const lastJsonRef = useRef<string | null>(null);

    const set = useCallback((value: T) => {
        const json = JSON.stringify(value);
        if (json === lastJsonRef.current) {
            return;
        }
        lastJsonRef.current = json;
        setState(value);
    }, []);

    return [state, set];
}
